import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RiskCategory } from '@commons/enums/vehicle.enum';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-network-warrning',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './network-warrning.component.html',
  styleUrls: ['./network-warrning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NetworkWarrningComponent {
  @Input() public risk: RiskCategory;

  public readonly RISK_CATEGORY = RiskCategory;
}
